module.exports = __webpack_public_path__ + "img/404.b9137cdb.jpg";